import styled, { css } from 'styled-components';

export const PairInputs = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PairWithSpace = styled(PairInputs)`
  margin-bottom: 10px;
`;

export const PairedInputMixin = css`
  width: 47.5%;
`;
